import React from 'react';
import PropTypes from 'prop-types';

function RightArrow({ active, activeColor, color }) {
  return (
    <path
      d="M242.823 205.127V226.102C242.823 229.971 239.687 233.108 235.818 233.108H217.487C215.629 233.108 213.848 232.37 212.534 231.056L202.367 220.89C199.631 218.154 199.631 213.718 202.367 210.983L212.87 200.481C214.154 199.196 215.887 198.461 217.703 198.43L235.698 198.123C239.613 198.056 242.823 201.212 242.823 205.127Z"
      fill={active ? activeColor : color}
    />
  );
}

RightArrow.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

RightArrow.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#4F535E',
};

export default RightArrow;
